import { Column, Index, OneToMany } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { MSmClientOpportunityEntity } from './m-sm-client-opportunity.entity';

/**
 * What reaching a stage means (sales relationships plan O1): still open, won
 * or lost. Each tenant keeps its own stage names; reports, the job offer on a
 * win and the Sales Helper read the outcome instead of guessing from a name.
 */
export const OPPORTUNITY_STAGE_OUTCOMES = ['open', 'won', 'lost'] as const;
export type OpportunityStageOutcome = (typeof OPPORTUNITY_STAGE_OUTCOMES)[number];

@Index('unique_name', ['mSmName'], { unique: true })
@Entity(
	'm_sm_client_opportunity_stage',
	{},
	{ label: 'Client Opportunity Stage' },
)
export class MSmClientOpportunityStageEntity extends BaseEntity {
	@Column('varchar', { name: 'm_sm_name', unique: true, length: 100 })
	public mSmName!: string;

	@Column('int', { name: 'm_sm_ordinal', unsigned: true, default: () => "'0'" })
	public mSmOrdinal!: number;

	@Column('int', {
		name: 'm_sm_probability',
		unsigned: true,
		default: () => "'50'",
	})
	public mSmProbability!: number;

	/**
	 * PD-17096 / PD-17101 — Open, Won or Lost. Default 'open'; a migration marks
	 * stages named "... Won" / "... Lost" on first run, and admins change it in
	 * Manage Stages. The database default keeps SM1's inserts working.
	 */
	@Column('varchar', { name: 'outcome', length: 8, default: () => "'open'" })
	public outcome!: OpportunityStageOutcome;

	@OneToMany(
		() => MSmClientOpportunityEntity,
		(mSmClientOpportunity) =>
			mSmClientOpportunity.mSmFkMSmClientOpportunityStage,
		{},
	)
	public mSmClientOpportunities!: Array<MSmClientOpportunityEntity>;
}
